// extracted by mini-css-extract-plugin
export var allJointSolutions = "index-module--allJointSolutions--fijJ-";